import moment from 'jalali-moment'

const persianDay = (date: Date | string, format = 'dddd') => {
  return moment(date, 'YYYY/MM/DD HH:mm:ss').locale('fa').format(format)
}

export default persianDay
